// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5ce1c62d","455":"48306eee","977":"225305a8"}[chunkId] + ".chunk.js";
};